import React, { useEffect, useState } from "react";
import "./verticalAccordion.scss";
import { BeditProfileData } from "../../../../components/Data/bEditData";
import { editIconBlue, images } from "../../../../images";
import { Link } from "react-router-dom";
import config from "../../../../config/config";
import LoadingStateComp from "../LoadingStateComp/LoadingStateComp";
import GalleryEditPopupDefault from "../../BusinessProfileComponents/PopUpComponents/GalleryEditPopups/GalleryEditPopupDefault";
import GalleryEditPopupDefaultV2 from "../../BusinessProfileComponents/PopUpComponents/GalleryEditPopups/GalleryEditPopupDefaultV2";
import AddImageComponent from "../AddImageComponent/AddImageComponent";
import LongPressGalleryPopup from "../../BusinessProfileComponents/PopUpComponents/GalleryEditPopups/LongPressGalleryPopup";
import { useWindowSize } from "react-use";
import BlurGalleryImage from "../../../../components/BlurGalleryImage/BlurGalleryImage";

const galleryTitles = [
  { key: "project_renders_media", title: "Project Photos & Renders" },
  { key: "completed_products_media", title: "Products | Materials" },
  { key: "sites_inprogress_media", title: "Sites In Progress" },
  { key: "others_media", title: "Others" },
];

const VerticalAccordion2 = ({
  isActive,
  isSubtabActive,
  galleryData,
  setOverlayActive,
  contentLoaded,
  isInitialLoad,
  // isScrapingContent,
  // scrapingError,
}) => {
  const [selectedIndex, setSelectedIndex] = useState({});
  const [selectedCategory, setSelectedCategory] = useState({});
  const imageUrl = config.aws_object_url + "business/";
  const handleItemHover = (galIndex, imgIndex) => {
    setSelectedIndex((prev) => ({
      ...prev,
      [galIndex]: imgIndex, // Maintain separate hover states per gallery_wrapper
    }));
  };
  const { width } = useWindowSize();

  const getProperImageUrl = (url) => {
    if (url?.startsWith("http://") || url?.startsWith("https://")) {
      return url;
    }
    return `${imageUrl}${url}`;
  };

  useEffect(() => {
    const defaultSelection = {};
    galleryTitles.forEach((title, index) => {
      if (
        galleryData &&
        galleryData[title.key] &&
        galleryData[title.key].length > 0
      ) {
        defaultSelection[title.key] = 0; // First image active by default
      }
    });

    setSelectedIndex(defaultSelection);
  }, [galleryData]);

  useEffect(() => {
    galleryTitles.forEach((title) => {
      if (
        galleryData &&
        galleryData[title.key] &&
        galleryData[title.key].length > 0 &&
        (selectedIndex[title.key] === undefined ||
          selectedIndex[title.key] >= galleryData[title.key].length)
      ) {
        setSelectedIndex((prev) => ({
          ...prev,
          [title.key]: 0,
        }));
      }
    });
  }, [galleryData]);

  const [showPopup, setShowPopup] = useState(false);
  const [showPopupLongPress, setShowPopupLongPress] = useState(false);
  const handlePopupOpen = (category) => {
    setSelectedCategory({ category, data: galleryData });
    setShowPopup(true);
  };
  const handlePopupClose = () => setShowPopup(false);
  const handlePopupOpenLongPress = (category) => {
    setSelectedCategory({ category, data: galleryData });
    setShowPopupLongPress(true);
  };

  const getBlurItem = (image) => ({
    src: getProperImageUrl(image.url),
    width: image.width,
    height: image.height,
    blurHash: image.blurHash,
    visibility: image.visibility,
  });

  // --- Pinterest masonry: combine all categories into one flat array ---
  const allImages = galleryTitles.flatMap((category) => {
    const categoryImages = galleryData?.[category.key] || [];
    const pinnedImages = categoryImages.filter((it) => it.pinned === true);
    if (pinnedImages.length > 0) {
      return [
        ...pinnedImages,
        ...categoryImages.filter((img) => !img.pinned && img.visibility),
      ].slice(0, 10);
    }
    return categoryImages.filter((img) => img.visibility).slice(0, 10);
  });

  // Open edit popup for first category (popup has internal category tabs)
  const handleEditAll = () => {
    handlePopupOpen(galleryTitles[0]);
  };

  const handlePopupCloseLongPress = () => setShowPopupLongPress(false);
  return (
    <>
      {/* <GalleryEditPopupDefaultV2
        show={showPopup}
        onHide={() => handlePopupClose(false)}
        handleClose={handlePopupClose}
        categoryData={selectedCategory}
      /> */}
      <GalleryEditPopupDefault
        show={showPopup}
        onHide={() => handlePopupClose(false)}
        handleClose={handlePopupClose}
        categoryData={selectedCategory}
      />
      <LongPressGalleryPopup
        show={showPopupLongPress}
        onHide={() => handlePopupClose(false)}
        handleClose={handlePopupCloseLongPress}
        categoryData={selectedCategory}
      />
      <div className="my_container">
        {/* ====== NEW: Pinterest-style combined masonry gallery ====== */}
        <div className="gallery_container active">
          {allImages.length > 0 ? (
            <div className="gallery_wrapper">
              <div className="cta_container">
                <h2 className="title">Gallery</h2>
                <div
                  className="cta_wrapper p-0"
                  onClick={handleEditAll}
                >
                  <img
                    src={editIconBlue}
                    alt="edit icon"
                    className="edit_icon"
                  />
                  <Link to={() => false} className="bedit_common_cta">
                    Edit | View
                  </Link>
                </div>
              </div>
              <div className="pinterest_masonry">
                {allImages.map((image, index) => (
                  <div className="pinterest_item" key={image._id || index}>
                    <BlurGalleryImage
                      item={getBlurItem(image)}
                      activeGallerImages={false}
                    />
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="gallery_wrapper">
              <div className="cta_container">
                <h2 className="title">Gallery</h2>
                <div
                  className="cta_wrapper p-0"
                  onClick={handleEditAll}
                >
                  <img
                    src={editIconBlue}
                    alt="edit icon"
                    className="edit_icon"
                  />
                  <Link to={() => false} className="bedit_common_cta">
                    Edit | View
                  </Link>
                </div>
              </div>
              <AddImageComponent
                title="Gallery"
                category={galleryTitles[0]}
              />
            </div>
          )}
        </div>

        {/* ====== OLD CATEGORIZED GALLERY (commented out) ====== */}
        {/* <div className={`gallery_container active`}>
          {galleryTitles.map((category, categoryIndex) => {
            const categoryImages = galleryData?.[category.key] || [];

            const pinnedImages =
              categoryImages?.filter((it) => it.pinned === true) || [];
            const hasScrapedContent =
              galleryData?.last_updated_scraped_content != null;
            return (
              <div className="gallery_wrapper" key={categoryIndex}>
                <div className="cta_container">
                  <h2 className="title">{category.title}</h2>
                  {((hasScrapedContent && categoryImages.length === 0) ||
                    categoryImages.length > 0) && (
                    <div
                      className="cta_wrapper p-0"
                      onClick={() => handlePopupOpen(category)}
                    >
                      <img
                        src={editIconBlue}
                        alt="edit icon"
                        className="edit_icon"
                      />
                      <Link to={() => false} className="bedit_common_cta">
                        Edit | View
                      </Link>
                    </div>
                  )}
                </div>
                {categoryImages.length === 0 && (
                  <AddImageComponent
                    title={category.title}
                    category={category}
                  />
                )}

                {categoryImages.length > 0 &&
                  (categoryImages.every(({ visibility }) => !visibility) ? (
                    <AddImageComponent
                      title={category.title}
                      category={category}
                    />
                  ) : (
                    <div className={`vaccodion_container`}>
                      {!setOverlayActive && (
                        <div className="overlay_vertical_acoordian"></div>
                      )}
                      <ul className="vaccordion_list_wrapper vaccordion_list_wrapper--fixes">
                        {(pinnedImages.length > 0
                          ? [
                              ...pinnedImages,
                              ...categoryImages.filter(
                                (img) => !img.pinned && !img.visibility,
                              ),
                            ]
                          : categoryImages?.filter((img) => img.visibility)
                        )
                          .slice(0, 5)
                          .map((image, imgIndex) => {
                            const isSelected =
                              selectedIndex[category.key] === imgIndex;
                            return (
                              <li
                                key={`${image.url}-${imgIndex}`}
                                className={`vaccordion_list ${
                                  isSelected ? "selected" : ""
                                }`}
                                onMouseOver={() =>
                                  handleItemHover(category.key, imgIndex)
                                }
                              >
                                <BlurGalleryImage
                                  item={getBlurItem(image)}
                                  activeGallerImages={false}
                                />
                              </li>
                            );
                          })}
                      </ul>
                    </div>
                  ))}
              </div>
            );
          })}
        </div> */}
        {/* ====== END OLD CATEGORIZED GALLERY ====== */}
      </div>
    </>
  );
};

export default VerticalAccordion2;
